import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ReceiptComponent,
  ReceiptDisplay,
} from '../../components/receipt/receipt.component';
import {
  CardReceiptDto,
  FileParameter,
  GetCardFilterStructureQuery,
  GetCardReturnsUploadedTodayQuery,
  ICardReceiptDto,
} from '@tech/api-clients/receipts';
import {
  IFilters,
  PermanentTablePaginatedComponent,
} from '../../components/permanent-table-paginated/permanent-table-paginated.component';
import { MatDialog } from '@angular/material/dialog';
import { FileProcessorService } from '@app/shared/services/wasm/file-processor/file-processor.service';
import { NotificationService } from '@app/shared/services/notification/notification.service';
import { NotificationhubService } from '@app/shared/services/notificationhub/notificationhub.service';

import { CardReturnClient } from '@tech/api-clients/receipts';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { PrettyConsole } from '@app/shared/utils';
import { PermanentTableComponent } from '../../components/permanent-table/permanent-table.component';

@Component({
  selector: 'app-receipt-card-return',
  standalone: true,
  imports: [ReceiptComponent, TranslateModule],
  templateUrl: './receipt-card-return.component.html',
  styleUrl: './receipt-card-return.component.scss',
})
export class ReceiptCardReturnComponent extends ReceiptComponent {
  override display_columns = [
    'file',
    'err_line',
    ...Object.keys(CardReceiptDto).map((c) => c.toUpperCase()),
  ];
  override staged_receipts: ReceiptDisplay[] = [];
  override sse_name = 'CardReturn';
  override available_filters: IFilters[] = [];
  override upload_field_text = 'Card Returns';
  _validation_schema: {};
  _wasm_split_pattern: string = ';';

  constructor(
    dialog: MatDialog,
    fileProcessor: FileProcessorService,
    notify: NotificationService,
    hub: NotificationhubService,
    private child_client: CardReturnClient
  ) {
    super(dialog, fileProcessor, notify, hub);
    this.sse_name = 'CardReturn';
    this.validation_schema = {};
    this.upload_handler = this.upload_files_client.bind(this);
    this.lookupPermanent = this.look_today.bind(this);
    this.callme = this.lookup_all.bind(this);
    this.get_paginated_data = this.get_paginated_data.bind(this);
    this.child_client
      .getCardReturnFilterStructure(GetCardFilterStructureQuery.fromJS({}))
      .subscribe({
        next: (x) => {
          var parsed = JSON.parse(x);
          this.available_filters = parsed;
        },
        error: (e) => {
          PrettyConsole.ERROR(
            `Something failed while getting filter structure ${e}`
          );
        },
      });
	this._validation_schema = {
	};
  }

  upload_files_client = (files: FileParameter[]) => {
    return this.child_client.uploadCardReturnFiles(files);
  };

  look_today = () => {
    const loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
    const ds = new PermanentTransferReceipts();
    this.child_client
      .getCardReturnsOfToday(GetCardReturnsUploadedTodayQuery.fromJS({}))
      .subscribe({
        next: (receipts) => {
          ds.setData(receipts);
          loading$.next(false);
        },
        error: (err) => {
          PrettyConsole.ERROR(
            `getTransferReceiptsOfToday got error on subscribe ${err}`
          );
          loading$.next(false);
        },
      });
    this.dialog.open(PermanentTableComponent<PermanentTransferReceipts>, {
      width: '85vw',
      height: '80vh',
      data: {
        title: 'Receipts of last remittance',
        receipts: ds,
        display: Object.keys(CardReceiptDto.prototype.toJSON()),
        loading$,
        callback: this.lookup_all,
      },
    });
  };

  lookup_all = () => {
    this.dialog.closeAll();
    if (this.available_filters.length === 0) {
      this.child_client
        .getCardReturnFilterStructure(GetCardFilterStructureQuery.fromJS({}))
        .subscribe({
          next: (x) => {
            var parsed = JSON.parse(x);
            this.available_filters = parsed;
          },
          error: (e) => {
            PrettyConsole.ERROR(
              `Something failed while getting filter structure ${e}`
            );
          },
        });
    }
    const data_source = new PermanentTransferReceipts();
    this.dialog.open(PermanentTablePaginatedComponent<ICardReceiptDto>, {
      width: '100vw',
      maxWidth: '98vw',
      height: '95vh',
      data: {
        receipts: data_source,
        display: Object.keys(CardReceiptDto.prototype.toJSON()).filter(
          (d) => d !== 'id'
        ),
        callback: this.get_paginated_data,
        filters: this.available_filters,
      },
    });
  };

  override get_paginated_data = (
    page: number,
    size: number,
    filters: IFilters[]
  ) => {
    let data = new BehaviorSubject<CardReceiptDto[]>([]);
    let count = new BehaviorSubject<number>(0);

    let filter_values: Record<string, any> = {};
    filters.forEach((f) => {
      filter_values[f.id] = f.value === null ? undefined : f.value;
    });

    this.child_client
      .getAllCardReturns(page, size, JSON.stringify(filter_values))
      .subscribe({
        error: (_) => {
          PrettyConsole.ERROR(
            `Error while getting the Card return receipts. page: ${page}, size: ${size}`
          );
        },
        next: (d) => {
          if (d.count) count.next(d.count);
          if (d.receipts) data.next(d.receipts);
        },
      });
    return { count: count.asObservable(), data: data.asObservable() };
  };
}

export class PermanentTransferReceipts extends DataSource<ICardReceiptDto> {
  private data = new BehaviorSubject<ICardReceiptDto[]>([]);

  connect(): Observable<ICardReceiptDto[]> {
    return this.data.asObservable();
  }

  addRow(row: ICardReceiptDto) {
    const current = this.data.getValue();
    this.data.next([...current, row]);
  }

  setData(rows: CardReceiptDto[]) {
    const data = rows.map((r) => r.toJSON());
    this.data.next(data);
  }

  disconnect(): void {}
}
